// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loadSimple {
    width: 3.25em;
    transform-origin: center;
    animation: rotate4 2s linear infinite;
   }
   
   /* circle {
    fill: none;
    stroke: hsl(215, 61%, 18%);
    stroke-width: 2;
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
    stroke-linecap: round;
    animation: dash4 1.5s ease-in-out infinite;
   } */
   circle {
    fill: none;
    stroke: hsl(215, 61%, 18%);
    stroke-width: 0.5;
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
    stroke-linecap: round;
    /* animation: dash4 1.5s ease-in-out infinite; */
   }
.circleLoadSimple{
    stroke-width: 2;
    animation: dash4 1.5s ease-in-out infinite;
}
   .menuActionData circle{
    stroke: hsl(215, 100%, 92%);
   }
   @keyframes rotate4 {
    100% {
     transform: rotate(360deg);
    }
   }
   
   @keyframes dash4 {
    0% {
     stroke-dasharray: 1, 200;
     stroke-dashoffset: 0;
    }
   
    50% {
     stroke-dasharray: 90, 200;
     stroke-dashoffset: -35px;
    }
   
    100% {
     stroke-dashoffset: -125px;
    }
   }
   `, "",{"version":3,"sources":["webpack://./src/components/styles/LoadSimple.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,wBAAwB;IACxB,qCAAqC;GACtC;;GAEA;;;;;;;;MAQG;GACH;IACC,UAAU;IACV,0BAA0B;IAC1B,iBAAiB;IACjB,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;IACrB,gDAAgD;GACjD;AACH;IACI,eAAe;IACf,0CAA0C;AAC9C;GACG;IACC,2BAA2B;GAC5B;GACA;IACC;KACC,yBAAyB;IAC1B;GACD;;GAEA;IACC;KACC,wBAAwB;KACxB,oBAAoB;IACrB;;IAEA;KACC,yBAAyB;KACzB,wBAAwB;IACzB;;IAEA;KACC,yBAAyB;IAC1B;GACD","sourcesContent":[".loadSimple {\r\n    width: 3.25em;\r\n    transform-origin: center;\r\n    animation: rotate4 2s linear infinite;\r\n   }\r\n   \r\n   /* circle {\r\n    fill: none;\r\n    stroke: hsl(215, 61%, 18%);\r\n    stroke-width: 2;\r\n    stroke-dasharray: 1, 200;\r\n    stroke-dashoffset: 0;\r\n    stroke-linecap: round;\r\n    animation: dash4 1.5s ease-in-out infinite;\r\n   } */\r\n   circle {\r\n    fill: none;\r\n    stroke: hsl(215, 61%, 18%);\r\n    stroke-width: 0.5;\r\n    stroke-dasharray: 1, 200;\r\n    stroke-dashoffset: 0;\r\n    stroke-linecap: round;\r\n    /* animation: dash4 1.5s ease-in-out infinite; */\r\n   }\r\n.circleLoadSimple{\r\n    stroke-width: 2;\r\n    animation: dash4 1.5s ease-in-out infinite;\r\n}\r\n   .menuActionData circle{\r\n    stroke: hsl(215, 100%, 92%);\r\n   }\r\n   @keyframes rotate4 {\r\n    100% {\r\n     transform: rotate(360deg);\r\n    }\r\n   }\r\n   \r\n   @keyframes dash4 {\r\n    0% {\r\n     stroke-dasharray: 1, 200;\r\n     stroke-dashoffset: 0;\r\n    }\r\n   \r\n    50% {\r\n     stroke-dasharray: 90, 200;\r\n     stroke-dashoffset: -35px;\r\n    }\r\n   \r\n    100% {\r\n     stroke-dashoffset: -125px;\r\n    }\r\n   }\r\n   "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
